import * as React from 'react';

import { FieldGroup, Label, TextInput } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';

const FOOTER_COPYRIGHT_MAX_LENGTH = 256;

export function FooterCopyright(props: SitesCustomizationPanelProps) {
    const { settings, setSettings } = props;
    const placeholder = React.useMemo(() => {
        return '© My Company';
    }, []);

    return (
        <FieldGroup>
            <Label>Copyright text</Label>
            <TextInput
                value={settings.footer.copyright || ''}
                placeholder={placeholder}
                maxLength={FOOTER_COPYRIGHT_MAX_LENGTH}
                onChange={(event) => {
                    setSettings((prev) => ({
                        ...prev,
                        footer: {
                            ...prev.footer,
                            copyright: event.target.value,
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}
